module.exports = __webpack_public_path__ + "static/assets/0a5e2068d9a39e4fdd412a4834c33674.svg";